import {
  Box,
  Container,
  CssBaseline,
  Input,
  MenuItem,
  Select,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import { StyledButton } from "../../../components/common/Button";
import { useState } from "react";

export const countries = [
  {
    flag: "🇮🇳",
    code: "91",
  },
  {
    flag: "🇺🇸",
    code: "1",
  },
];

const GetInTouch = () => {
  const [selectedCountry, setSelectedCountry] = useState(countries[0]);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ backgroundColor: "#EEF6FF" }}>
        {isMobile ? (
          <Container
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                marginTop: "3.75rem",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 400,
                  fontSize: "0.625rem",
                  letterSpacing: "0.0047241188rem",
                  color: "#212121",
                }}
              >
                Want to learn more?
              </Typography>
            </Box>
            <Box
              sx={{
                marginTop: "0.5rem",
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: "1.375rem",
                  fontWeight: 700,
                  color: "#212121",
                }}
              >
                Get in Touch
                <Box sx={{ whiteSpace: "nowrap" }}>for a Personalized</Box>
                <Box sx={{ whiteSpace: "nowrap" }}>Educational Experience</Box>
              </Typography>
              <Box
                component="form"
                sx={{
                  "& > :not(style)": { m: 1 },
                  marginTop: "1.25rem",
                  display: "flex",
                  flexDirection: "column",
                }}
                noValidate
                autoComplete="off"
              >
                <Input placeholder="Your Name" />
                <Input placeholder="Name of your Institute" />
                <Input placeholder="Designation" />
                <Input placeholder="Email ID" />
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Select
                    value={selectedCountry}
                    onChange={handleCountryChange}
                    variant="standard"
                    sx={{ marginRight: "0.375rem" }}
                  >
                    {countries.map((country) => (
                      <MenuItem key={country.code} value={country}>
                        {country.flag}
                      </MenuItem>
                    ))}
                  </Select>
                  <Input
                    placeholder="Mobile No."
                    value={`+${selectedCountry.code}`}
                    sx={{ width: "100%" }}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  marginTop: "2.5rem",
                  marginBottom: "3.75rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <StyledButton
                  variant="contained"
                  height="1.5rem"
                  width="10.375rem"
                  style={{
                    backgroundColor: `${theme.palette.primary.main}`,
                    borderRadius: "1.022175rem",
                  }}
                >
                  <Typography sx={{ fontSize: "0.5rem" }}>
                    REACH OUT TODAY
                  </Typography>
                </StyledButton>
              </Box>
            </Box>
          </Container>
        ) : (
          <Container
            sx={{
              display: "flex",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flex: "1.5",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  marginTop: "11.0625rem",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 400,
                    fontSize: "1.125rem",
                    letterSpacing: "0.01rem",
                    color: "#212121",
                    whiteSpace: "nowrap",
                  }}
                >
                  Want to learn more?
                </Typography>
              </Box>
              <Box
                sx={{
                  marginTop: "1.25rem",
                  marginBottom: "13.0625rem",
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    width: "32rem",
                    fontSize: "2.75rem",
                    fontWeight: 700,
                    color: "#212121",
                  }}
                >
                  Get in Touch{"\n"}
                  for a Personalized{"\n"}
                  <Box sx={{ whiteSpace: "nowrap" }}>
                    Educational Experience
                  </Box>
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <Box
                component="form"
                sx={{
                  "& > :not(style)": { m: 1 },
                  marginTop: "7.5rem",
                  display: "flex",
                  flexDirection: "column",
                }}
                noValidate
                autoComplete="off"
              >
                <Input placeholder="Your Name" />
                <Input placeholder="Name of your Institute" />
                <Input placeholder="Designation" />
                <Input placeholder="Email ID" />
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Select
                    value={selectedCountry}
                    onChange={handleCountryChange}
                    variant="standard"
                    sx={{ marginRight: "0.75rem" }}
                  >
                    {countries.map((country) => (
                      <MenuItem key={country.code} value={country}>
                        {country.flag}
                      </MenuItem>
                    ))}
                  </Select>
                  <Input
                    placeholder="Mobile No."
                    value={`+${selectedCountry.code}`}
                    sx={{ width: "100%" }}
                  />
                </Box>
              </Box>
              <Box sx={{ marginTop: "2rem", marginBottom: "7.5rem" }}>
                <StyledButton
                  variant="contained"
                  height="3rem"
                  width="15.5rem"
                  style={{ backgroundColor: `${theme.palette.primary.main}` }}
                >
                  REACH OUT TODAY
                </StyledButton>
              </Box>
            </Box>
          </Container>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default GetInTouch;
